import configDev from "./config.dev";
import configInt from "./config.int";
import configUatAmprion from "./config.uat-amprion";
import configProd from "./config.prod";
import configProdAmprion from "./config.prod-amprion";
import configProdAmprionBackup from "./config.prod-amprion-backup";
import configLocal from "./config.local";

const env = process.env.REACT_APP_ENV_DEPLOY;

const configByEnv = () => {
    switch (env) {
        case 'dev':
            return configDev;
        case 'uat-amprion':
            return configUatAmprion;
        case 'int':
            return configInt;
        case 'prod':
            return configProd;
        case 'prod-amprion':
            return configProdAmprion;
        case 'prod-amprion-backup':
            return configProdAmprionBackup;
        default:
            return configLocal;
    }
};

const fallbackConfig = configByEnv();

const config = {
    BACK_BASE_URL: window._env_.BACK_BASE_URL !== "%BACK_BASE_URL%" ? window._env_.BACK_BASE_URL : fallbackConfig.BACK_BASE_URL,
    BACK_URL: window._env_.BACK_URL !== "%BACK_URL%" ? window?._env_?.BACK_URL : fallbackConfig.BACK_URL,
    KIBANA_URL: window._env_.KIBANA_URL !== "%KIBANA_URL%" ? window._env_.KIBANA_URL : fallbackConfig.KIBANA_URL
};


export default config;
